<template>
  <div class="footer mt-auto">
    <div class="container-fluid bg-dark py-5">
      <div class="row">
        <div class="col-md-6 mx-auto d-flex flex-column align-items-center">
          <div class="navbar-brand">
            <img
              src="../assets/image/logo2.svg"
              alt=""
            >
          </div>
          <div class="d-flex">
            <li class="nav-item">
              <a
                class="nav-link text-secondary"
                href="#activity"
              >特色活動</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-secondary"
                href="#restaurant"
              >美食饗宴</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-secondary"
                href="#hotel"
              >精選住宿</a>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.navbar-brand {
  margin-right: 0 rem;
  img {
    width: 7rem;
  }
}
</style>
